import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import classnames from 'classnames';
import { noop } from 'lodash';

const ANIMATION_DURATION = 200;

export default class AnimatedCounter extends PureComponent {
    static defaultProps = {
        facet: 'base',
        direction: 'auto',
        onFinish: noop,
    };

    static propTypes = {
        amount: PropTypes.number.isRequired,
        onChange: PropTypes.func,
        direction: PropTypes.string,
        facet: PropTypes.string,
        onFinish: PropTypes.func.isRequired,
        ariaLabel: PropTypes.string.isRequired,
        className: PropTypes.string,
        suffix: PropTypes.string,
        readonly: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = {
            isHighlighted: false,
            oldAmount: null,
            value: [props.amount],
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.amount !== this.props.amount) {
            this.updateID++;
            this.updateValue(nextProps.amount, this.props.amount);
        }
    }

    updateID = 0;

    get moveDown() {
        return {
            enterAnimation: {
                from: {
                    transform: 'translate(0, -150%)',
                },
                to: {
                    transform: 'translate(0, 0)',
                },
            },
            leaveAnimation: {
                from: {
                    transform: 'translate(0, 0)',
                },
                to: {
                    transform: 'translate(0, 150%)',
                },
            },
        };
    }

    get moveUp() {
        return {
            enterAnimation: {
                from: {
                    transform: 'translate(0, 150%)',
                },
                to: {
                    transform: 'translate(0, 0)',
                },
            },
            leaveAnimation: {
                from: {
                    transform: 'translate(0, 0)',
                },
                to: {
                    transform: 'translate(0, -150%)',
                },
            },
        };
    }

    updateValue = (amount, oldAmount) => {
        this.setState({
            isHighlighted: true,
            oldAmount,
            value: amount,
        });
    };

    render() {
        const { amount, className, onChange, suffix, readonly, facet, direction, ariaLabel, onFinish } = this.props;
        const { value, isHighlighted, oldAmount } = this.state;

        return (
            <div className={classnames('animated-counter', `animated-counter__${ facet }`, className, {
                'animated-counter__is-highlighted': isHighlighted,
            })}>
                <input
                    aria-label={ariaLabel}
                    readOnly={readonly}
                    className="animated-counter--input"
                    type="tel"
                    disabled={true}
                    value={amount}
                    onChange={e => onChange && onChange(e.target.value)}
                />
                <FlipMove
                    className="animated-counter--animator"
                    duration={ANIMATION_DURATION}
                    onFinish={onFinish}
                    staggerDurationBy={ANIMATION_DURATION}
                    {...((direction === 'auto' && value > oldAmount) || direction === 'up'
                        ? this.moveUp
                        : this.moveDown)}
                >
                    <div className="animated-counter--value" key={this.updateID}>
                        {value}
                        {suffix}
                    </div>
                </FlipMove>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/animated-counter/index.js